// extracted by mini-css-extract-plugin
export default {"setupLicense":"SetupLicense_setupLicense__XqKt6","contentHeader":"SetupLicense_contentHeader__V5OHP"};